<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <PostCard v-for="post in posts" :key="post.id" :post="post" />
      <!-- <v-flex v-for="post in posts" :key="post.id">
        <PostCard :post="post" v-if="post.active && post.status == 'published' && !post.filter" xs4/>
      </v-flex> -->
    </v-layout>
  </v-container>
</template>

<script>
  import PostCard from '@/components/PostCard'
  import { mapState } from 'vuex'
  export default {
    name: 'Home',
    components: {
      PostCard
    },
    data() {
      return {
        
      }
    },
    computed: mapState([
      'posts'
    ])
  }
</script>
